module.exports = __webpack_public_path__ + "img/frame-768.94e9575a.png";